<template>
  <div style="padding: 5px">
    <div id="content">
      <img :src=cover width="150px" height="90px">
      <p>{{ title }}</p>
    </div>
  </div>

</template>

<script>
export default {
  name: "ProductRectangle",
  props: ['index', 'title', 'cover']
}
</script>

<style scoped>
p {
  margin: 10px 0 5px 0;
  color: white;
}

#content {
  margin: 0 0 2px 0;
  padding: 10px 0 0 0;
  background-color: #2868a0;
  border: 1px solid #8d99cd;
  border-radius: 3px;
}

img {
  padding: 30px 0 10px 0;
}
</style>